import React, { useState } from 'react';
import Card from './common/Card';
import AuditChecklist from './AuditChecklist';
import { Button } from './common';

const FormsAndDocuments = () => {
  const [activeSection, setActiveSection] = useState(null);

  const handleSectionClick = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  if (activeSection === 'audit-checklists') {
    return (
      <div className="p-6">
        <div className="flex items-center mb-6">
          <Button
            variant="secondary"
            onClick={() => setActiveSection(null)}
            className="mr-4"
          >
            Back to Forms & Documents
          </Button>
          <h1 className="text-2xl font-bold">Audit Checklists</h1>
        </div>
        <AuditChecklist />
      </div>
    );
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Forms & Documents</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card 
          className="cursor-pointer hover:shadow-lg transition-shadow duration-200"
          onClick={() => handleSectionClick('audit-checklists')}
        >
          <h2 className="text-xl font-semibold mb-4">Audit Checklists</h2>
          <p className="text-gray-600">
            Create, manage, and export audit checklists. Includes templates and compliance verification tools.
          </p>
        </Card>

        <Card>
          <h2 className="text-xl font-semibold mb-4">Issue New CAR Form</h2>
          {/* New CAR Form component will go here */}
        </Card>

        <Card>
          <h2 className="text-xl font-semibold mb-4">IOSA Documentation</h2>
          {/* IOSA Documentation component will go here */}
        </Card>

        <Card>
          <h2 className="text-xl font-semibold mb-4">AOCR Documents</h2>
          {/* AOCR Documents component will go here */}
        </Card>

        <Card>
          <h2 className="text-xl font-semibold mb-4">AOCR - IOSA Cross Reference</h2>
          {/* Cross Reference component will go here */}
        </Card>

        <Card>
          <h2 className="text-xl font-semibold mb-4">Service Difficulty Report Template</h2>
          {/* SDR Template component will go here */}
        </Card>
      </div>
    </div>
  );
};

export default FormsAndDocuments;
